import { IonIcon } from "@ionic/react";
import { checkmarkSharp, closeSharp, helpOutline } from "ionicons/icons";
import { v4 } from "uuid";
import { IQuestion } from "./Quizz";

interface ICorrectionAnswerProps {
  userAnswers: Map<string, boolean>;
  questionIndex: number;
  question: IQuestion;
}

const getRelatedResponses = (
  questionIndex: number,
  answers: Map<string, boolean>
) => {
  const stringIndex = questionIndex.toString();
  const arr = Array.from(answers).filter(
    (value) => value[0].split("-")[0] === stringIndex
  );
  return arr;
};

const getCheckedResponses = (relatedResponses: [string, boolean][]) => {
  return relatedResponses
    .filter((resp) => resp[1] === true)
    .map((resp) => Number.parseInt(resp[0].split("-")[1]));
};

const CorrectionAnswer: React.FC<ICorrectionAnswerProps> = ({
  userAnswers,
  questionIndex,
  question,
}) => {
  const relatedResponses = getRelatedResponses(questionIndex, userAnswers);
  const checkedResponse = getCheckedResponses(relatedResponses);

  const relatedValides = question.valide.map((index) => Number.parseInt(index));
  const goodResponses = relatedResponses.filter((resp) =>
    relatedValides.includes(Number.parseInt(resp[0].split("-")[1]))
  );

  return (
    <div
      key={v4()}
      style={{
        color: "black",
        width: "100%",
        borderBottom: "1px solid lightgrey",
        margin: 5,
        padding: 5,
      }}
    >
      {checkedResponse.map((answer) => (
        <div
          key={v4()}
          style={{
            color: "black",
            width: "100%",
            borderBottom: "1px solid lightgrey",
            margin: 5,
            padding: 5,
          }}
        >
          {relatedValides.includes(answer) ? (
            <IonIcon icon={checkmarkSharp} className="green" />
          ) : (
            <IonIcon icon={closeSharp} className="red" />
          )}

          {question.awnser[answer]}
        </div>
      ))}
      {goodResponses.length !== relatedValides.length && (
        <>
          <IonIcon
            style={{
              paddingLeft: 10,
            }}
            icon={helpOutline}
            className="black-text"
          />
          Il te manque une ou plusieurs réponses
        </>
      )}
    </div>
  );
};

export default CorrectionAnswer;
